<template>
  <!-- Silded para prmociones -->
  <div class="col-12 contenidoSlider" v-if="banSettingsTA">
    <p class="superTitle px-3">{{tituloPromos}}</p>
    <Loader v-if="!banImg" />
    <agile v-if="banImg" class="container-fluid" :nav-buttons="false" autoplay="autoplay" :autoplay-speed="5000" :speed="2500" fade="fade" pause-on-hover="pause-on-hover" pause-on-dots-hover="pause-on-dots-hover">

      <div class="slidePromo d-flex flex-wrap slide--1" v-for="(promo, key) in promos" v-bind:key="'_promos' + key">
        <div class="col-lg-6 col-12 imgPromo">
          <picture>
            <source media="(max-width: 992px)" :id="'img' + key" :srcset="promo.bannerImageMobile">
            <img class="imagenPromo" :id="'img' + key" :src="promo.bannerImageDesktop">
          </picture>
        </div>
        <div class="col-lg-6 col-12 promoInfo">
          <div class="col-12 bodyPromo">
            <p class="titlePromo">{{promo.bannerName}}</p>
            <p class="subtitlePromo mb-3">{{promo.bannerShortDescription}}</p>
            <p class="parrafoPromo mb-3">{{promo.bannerDescription}}:</p>
            <p class="tipoPromo">{{promo.bannerBenefits}}</p>
          </div>
        </div>
      </div>
    </agile>

 <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->


  </div>
</template>

<script>
  import * as GlobalServices from '../../utils/GlobalServices';
  import * as GlobalFunctions from '../../utils/GlobalFunctions';
  import { VueAgile } from '../../customComponents/vue-agile';
  import SecureLS from 'secure-ls'
  import i18n from '../../plugins/i18n';
  import Loader from '../loader/Loader';
  import Modal from '../addons/Modal.vue'
 
export default {
  components: {
    agile: VueAgile,
    Loader,
    Modal
  },
  name: 'promos',
  data:() => {
    return {
      banSettingsTA: false,
      contActualizaComponente: 0,
      ls: new SecureLS({ encodingType: "aes" }),
      isExpiredModalVisible: false,
      banImg: false,
      contBanImg: 0,
      promos:[],
			options1: {
				dots: false,
				fade: true,
				navButtons: false
			},
			options2: {
				autoplay: true,
				centerMode: true,
				dots: false,
				navButtons: false,
				slidesToShow: 3,
				responsive: [
          {
            breakpoint: 600,
            settings: {
                slidesToShow: 5
            }
          },
          {
            breakpoint: 1000,
            settings: {
                navButtons: true
            }
          }
        ]
      },
    }
  },
  computed: {
    tituloPromos() {
      if (this.contActualizaComponente === 0) {
        this.contActualizaComponente++;
      } else {
        this.banners(2);
      }
      return i18n.t('language.posadasCorporate.promos.promocionesEspeciales');
    }
  },
  methods: {
    closeExpiredModal() {
  this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
             GlobalFunctions.localStorageClean();
                this.$router.push({ name: "Login" });
    },
    banners(lugar){
      if (this.contBanImg === 0) {
        this.contBanImg ++;
      } else{
        this.banImg = false;
      }
      setTimeout(() => {
        this.consultaBanners(lugar);
      }, 1);
    },
    consultaBanners(lugar){
      if (this.ls.get('PromosBanners') === null || this.ls.get('PromosBanners') === undefined || this.ls.get('PromosBanners') === '') {
        GlobalServices._consultaBanners(this.ls.get('Token').data, this.ls.get('Language').data).then(response => {
          if (response.status === 200) {
            this.promos = response.data;
            this.ls.set('PromosBanners', { data: response.data });
            this.banImg = true;
          }      
        }).catch(error => {
          this.banImg = false;
          if (error.status === 401) {
              //token caduco
              this.sesionClose();
            }
        });
      } else {
        if (this.ls.get('PromosBanners') !== '' && lugar === 2) {
          GlobalServices._consultaBanners(this.ls.get('Token').data, this.ls.get('Language').data).then(response => {
            if (response.status === 200) {
              this.promos = response.data;
              this.ls.set('PromosBanners', { data: response.data });
              this.banImg = true;
            }      
          }).catch(error => {
            this.banImg = false;
            if (error.status === 401) {
              //token caduco
              this.sesionClose();
            }
          });
        } else {
          this.promos = this.ls.get('PromosBanners').data;
          this.banImg = true;
        }
      }
    }
  },
  created(){
    this.banners(1);
//START KB58887 - configuraciones user TA  
    var ls = new SecureLS({ encodingType: "aes" });
    var readingProfile = ls.get("Profile");
        
    var ProfileType = "";
    if(readingProfile){
      ProfileType = readingProfile.data.profileType;
    }

    if(ProfileType == 'TA'){
          GlobalServices._searchConfigTA(this.ls.get("Token").data).then(response => {
            if (response.status == 200) {
                response.data.response.forEach(item => {
                    var test=item.title;
                    if(test == "SPECIAL_SALES" && item.flag== "TRUE"){
                        console.log("componente bloqueado video");
                        this.banSettingsTA = true;
                      }
                    });
                  }
            })
            .catch(error => {
              console.log("error: "+error)
            });  
            }else{
              this.banSettingsTA = true;
              }
   //END KB58887
  },
  sesionClose(){
           this.isExpiredModalVisible = true

  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/scss/config.scss';
  .imagenPromo {
    width: 100%;
    height: 100%;
    max-width: 500px;
  }
  .imgPromo {
    height: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bodyPromo {
    padding: 51px 20px;
  }
  .promoInfo {
    position: absolute;
    top: 0;
    right: 0;
  }
  .slidePromo {
    height: 280px;
    background-color: #efece7;
  }
  .titlePromo {
    font-size: $font-size-h3;
    font-weight: bold;
    line-height: 1.23;
    letter-spacing: 0.4px;
  }
  .subtitlePromo {
    font-size: $font-size-large;
    font-weight: 500;
    line-height: 1.31;
    letter-spacing: 0.4px;
  }
  .parrafoPromo {
    font-size: $font-size-base;
    line-height: 1.29;
    letter-spacing: 0.4px;
  }
  .tipoPromo {
    font-size: $font-size-base;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: 0.4px;
  }
  button,
  .button {
    margin: 10px;
  }
    @media only screen and (max-width: 992px) {
    .imgPromo {
      position: relative;
      width: 100%;
    }
    .imagenPromo {
      height: 250px;
    }
    .bodyPromo {
      padding: 20px;
    }
    .promoInfo {
      position: relative;
      top: 0;
      right: 0;
    }
    .slidePromo {
      height: auto;
    }
  }
</style>